module.exports = __webpack_public_path__ + "static/boat3-2db7b17d0836a7c25559137a3d302b1d.jpg";